import BaseImportProjectsView from "backbone/projects/views/base_import_projects_view.js"
import Template from "backbone/projects/templates/scrape.js.hamlc"
import ClipPublicationView from "backbone/projects/views/clip_publication_view.js"

export default class ScrapePublicationView extends BaseImportProjectsView
  events:
    "submit form"                    : "startImport"
    "click .js-add-clip-publication" : "addNewClipPublication"
    "click .js-new-cancel"           : "remove"

  renderedHtml: ->
    Template(collection: @collection, newClipPub: @newClipPub)

  setupForm: ->
    @clipPublicationView = new ClipPublicationView
      el: @$el.find(".js-clip-publication-search")

  render: ->
    super
    @setupForm()
    this

  addNewClipPublication: ->
    @newClipPub = true
    @render()

  startImport: (e) ->
    e.preventDefault() if e
    $form = $(@$el.find("form"))
    if $form.parsley().validate()
      $form.maskLoading()
      $.ajax
        url: $form.attr('action')
        data: $form.serialize()
        processData: false
        contentType: false
        type: 'GET'
        success: (data) =>
          if data.count > 0
            for url in data.urls
              @collection.add(url: url)
            @afterSearch(count: data.count) if @afterSearch
          else
            contently.flash.notice("Sorry, we were unable to find any projects for that client or publication. You can add those items manually, or try another client.")
            @importInProgress = false
          @render()
        error: (xhr, status, error) ->
          @enableBack()
          $form.unmaskLoading()
          contently.flash.alert("Sorry, there was an problem scraping that publication.")



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/scrape_publication_view.js.coffee